import FalconComponentCard from "components/common/FalconComponentCard";
import { PhonesNumber } from "components/phonesNumber/phonesNumber";
import { PhonesNumberSend } from "components/phonesNumber/phonesNumberSend";
import AppContext from "context/Context";
import EmojiPicker from "emoji-picker-react";
import { LabelForm } from "hooks/useLabelForm"
import { CustomPopover } from "hooks/usePopover"
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap"
import { BsEmojiSmileFill } from "react-icons/bs";
import { FaCog, FaList, FaPaperPlane } from "react-icons/fa";
import { labelDefaultList } from '../../helpers/utils';
import { useModal } from 'hooks/useModal';
import { toast } from 'react-toastify';
import { updateOrderHook } from "services/webHookService";
import { Templates } from "hooks/useMessagingTemplates";

export const ConfigurationForm = ({
    hookId,
    hookName,
    messageInitial,
    fieldsInitial, 
    setIsLoading,
    loadHooks,
    onCancel,
    isLoadingInitial = false
}) => {
    const allowedGSMChars = `@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^|€{}[]~`;
    const [labels] = useState([...labelDefaultList]);
    const [valuesConfig, setValuesConfig] = useState({ message: messageInitial, fields: fieldsInitial });
    const { message, fields } = valuesConfig;
    const [messageInfo, setMessageInfo] = useState({
        length: 0,
        count: 0
    });
    const [isSpecialChar, setIsSpecialChar] = useState(true);
    const [labelSelected, setLabelSelected] = useState([]);
    const [toggleConfigMessages, CenteredModalConfigMessages] = useModal(false);
    const [toggleConfigPhones, CenteredModalConfigPhones] = useModal(false);
    const [toggleSendPhones, CenteredModalSendPhones] = useModal(false);
    const [validated, setValidated] = useState(false);
    const [messageEdit, setMessageEdit] = useState(null);

    const {
        setBreadcrumbs
    } = useContext(AppContext);        

    useEffect(() => {
        setBreadcrumbs('');
        setValuesConfig({ message: messageInitial || '', fields: fieldsInitial || [] });
        processMessage(messageInitial || '');        
    }, [messageInitial]);

    const useHandleChangeForm = ({ target }) => {
        let newValue = target.value;
        if (!isSpecialChar) {
            newValue = newValue.split('').filter(char => allowedGSMChars.includes(char)).join('');
        }
        processMessage(newValue);
        setValuesConfig({...valuesConfig, message: newValue});    
    };

    const isSpecialCharacters = (msn) => {
        const regexCharacters = /[ÁáÉéÍíÓóÚúÑñüÜ!¡@#$%^&*=,;:\-¿?_<>/]/g;
        let characteres = msn.match(regexCharacters);
  
        if (!!characteres) {
          return true;
        }
  
        const regexEmojic = /[😀|😁|😂|🤣|😃|😄|😅|😆|😉|😊|😋|😎|😍|😘|😗|😙|😚|🙂|🤗|🤔|😐|😑|😶|🙄|😏|😣|😥|😮|🤐|😯|😪|😫|😴|😌|😛|😜|😝|🤤|😒|😓|😔|😕|🙃|🤑|😲|☹|🙁|😖|😞|😟|😤|😢|😭|😦|😧|😨|😩|😬|😰|😱|😳|😵|😡|😠|😷|🤒|🤕|🤢|🤧|😇|🤠|🤡|🤥|🤓|😈|👿|👹|👺|💀|👻|👽|🤖|💩|😺|😸|😹|😻|😼|😽|🙀|😿|😾|👶|👧|👦|👩|👨|👵|👴|👲|👳‍♀|👳‍♂|👱‍♂|👱‍♀|👮‍♀|👮‍♂|👷‍♀|👷‍♂|💂‍♀|💂‍♂|🕵‍♀|🕵‍♂|👩‍⚕|👨‍⚕|👩‍🌾|👨‍🌾|👩‍🍳|👨‍🍳|👩‍🎓|👨‍🎓|👩‍🎤|👨‍🎤|👩‍🏫|👨‍🏫|👩‍🏭|👨‍🏭|👩‍💻|👨‍💻|👩‍💼|👨‍💼|👩‍🔧|👨‍🔧|👩‍🔬|👨‍🔬|👩‍🎨|👨‍🎨|👩‍🚒|👨‍🚒|👨‍✈|👩‍🚀|👨‍🚀|👩‍⚖|👨‍⚖|👰|🤵|👸|🤴|🤶|🎅|👼|🤰|🙇‍♀|🙇‍♂|💁‍♀|💁‍♂|🙅‍♀|🙅‍♂|🙆‍♀|🙆‍♂|🙋‍♀|🙋‍♂|🤦‍♀|🤦‍♂|🤷‍♀|🤷‍♂|🙎‍♀|🙎‍♂|🙍‍♀|🙍‍♂|💇‍♀|💇‍♂|💆‍♀|💆‍♂|💅|🤳|💃|🕺|👯‍♀|👯‍♂|🕴|🚶‍♀|🚶‍♂|🏃‍♀|🏃‍♂|👫|👭|👬|💑|👩‍❤‍👩|👨‍❤‍👨|💏|👩‍❤‍💋‍👩|👨‍❤‍💋‍👨|👪|👨‍👩‍👧|👨‍👩‍👧‍👦|👨‍👩‍👦‍👦|👨‍👩‍👧‍👧|👩‍👩‍👦|👩‍👩‍👧|👩‍👩‍👧‍👦|👩‍👩‍👦‍👦|👩‍👩‍👧‍👧|👨‍👨‍👦|👨‍👨‍👧|👨‍👨‍👧‍👦|👨‍👨‍👦‍👦|👨‍👨‍👧‍👧|👩‍👦|👩‍👧|👩‍👧‍👦|👩‍👦‍👦|👩‍👧‍👧|👨‍👦|👨‍👧|👨‍👧‍👦|👨‍👦‍👦|👨‍👧‍👧|👐|🙌|👏|🤝|👍|👎|👊|✊|🤛|🤜|🤞|✌|🤘|👌|👈|👉|👆|👇|☝|✋|🤚|🖐|🖖|👋|🤙|💪|🖕|✍|🙏|💍|💄|💋|👄|👅|👂|👃|👣|👁|👀|🗣|👤|👥|👚|👕|👖|👔|👗|👙|👘|👠|👡|👢|👞|👟|👒|🎓|⛑|👑|👝|👛|👜|💼|🎒|👓|🕶|🎩|🌂|👶🏻|👦🏻|👧🏻|👨🏻|👩🏻|👱🏻‍♀|👱🏻|👴🏻|👵🏻|👲🏻|👳🏻‍♀|👳🏻|👮🏻‍♀|👮🏻|👷🏻‍♀|👷🏻|💂🏻‍♀|💂🏻|🕵🏻‍♀|🕵🏻|👩🏻‍⚕|👨🏻‍⚕|👩🏻‍🌾|👨🏻‍🌾|👩🏻‍🍳|👨🏻‍🍳|👩🏻‍🎓|👨🏻‍🎓|👩🏻‍🎤|👨🏻‍🎤|👩🏻‍🏫|👨🏻‍🏫|👩🏻‍🏭|👨🏻‍🏭|👩🏻‍💻|👨🏻‍💻|👩🏻‍💼|👨🏻‍💼|👩🏻‍🔧|👨🏻‍🔧|👩🏻‍🔬|👨🏻‍🔬|👩🏻‍🎨|👨🏻‍🎨|👩🏻‍🚒|👨🏻‍🚒|👩🏻‍✈|👨🏻‍✈|👩🏻‍🚀|👨🏻‍🚀|👩🏻‍⚖|👨🏻‍⚖|🤶🏻🎅🏻|👸🏻|🤴🏻🙇🏻‍♀|🙇🏻|💁🏻|💁🏻‍♂|🙅🏻|🙅🏻‍♂|🙆🏻|🙆🏻‍♂|🙋🏻|🙋🏻‍♂|🤦🏻‍🙎🏻|🙎🏻‍♂|🙍🏻|🙍🏻‍♂|💇🏻|💇🏻‍♂|💆🏻|💆🏻‍♂|🕴🏻|💃🏻|🕺🏻|🚶🏻‍♀|🚶🏻|🏃🏻‍♀|🏃🏻|👐🏻|🙌🏻|👏🏻|🙏🏻|👍🏻|👎🏻|👊🏻|✊🏻|✌🏻🤘🏻|👌🏻|👈🏻|👉🏻|👆🏻|👇🏻|☝🏻|✋🏻|🤚|🖐🏻|🖖🏻|👋🏻|🤙|💪🏻|🖕🏻|💅🏻|👂🏻|👃🏻|👶🏾|👦🏾|👧🏾|👨🏾|👩🏾|👱🏾‍♀|👱🏾|👴🏾|👵🏾|👲🏾|👳🏾‍♀|👳🏾|👮🏾‍♀|👮🏾|👷🏾‍♀|👷🏾|💂🏾‍♀|💂🏾|🕵🏾‍♀|🕵🏾|👩🏾‍⚕|👨🏾‍⚕|👩🏾‍🌾|👨🏾‍🌾|👩🏾‍🍳|👨🏾‍🍳|👩🏾‍🎓|👨🏾‍🎓|👩🏾‍🎤|👨🏾‍🎤|👩🏾‍🏫|👨🏾‍🏫|👩🏾‍🏭|👨🏾‍🏭|👩🏾‍💻|👨🏾‍💻|👩🏾‍💼|👨🏾‍💼|👩🏾‍🔧|👨🏾‍🔧|👩🏾‍🔬|👨🏾‍🔬|👩🏾‍🎨|👨🏾‍🎨|👩🏾‍🚒|👨🏾‍🚒|👩🏾‍✈|👨🏾‍✈|👩🏾‍🚀|👨🏾‍🚀|👩🏾‍⚖|👨🏾‍⚖|🤶🏾|🎅🏾|👸🏾|🤴🏾|👰|👼🏾|🤰🏾|🙇🏾‍♀|🙇🏾|💁🏾|💁🏾‍♂|🙅🏾|🙅🏾‍♂|🙆🏾|🙆🏾‍♂|🙋🏾|🙋🏾‍♂|🤦🏾‍🏾‍♂|🙎🏾|🙎🏾‍♂|🙍🏾|🙍🏾‍♂|💇🏾|💇🏾‍♂|💆🏾|💆🏾‍♂|🕴🏾|💃🏾|🕺🏾|🚶🏾‍♀|🚶🏾|🏃🏾‍♀|🏃🏾|👐🏾|🙌🏾|👏🏾|🙏🏾|👍🏾|👎🏾|👊🏾|✊🏾|🤛🏾🤜|✌🏾🤘🏾|👌🏾|👈🏾|👉🏾|👆🏾|👇🏾|☝🏾|✋🏾|🤚🏾|🖐🏾|🖖🏾|👋🏾|🤙🏾|💪🏾|🖕🏾|✍🏾|🤳🏾💅🏾|👂🏾|👃🏾|🐶|🐱|🐭|🐹|🐰|🦊|🐻|🐼|🐨|🐯|🦁|🐮|🐷|🐽|🐸|🐵|🙈|🙉|🙊|🐒|🐔|🐧|🐦|🐤|🐣|🐥|🦆|🦅|🦉|🦇|🐺|🐗|🐴|🦄|🐝|🐛|🦋|🐌|🐚|🐞|🐜|🕷|🕸|🦂|🐢|🐍|🦎|🐙|🦑|🦐|🦀|🐡|🐠|🐟|🐬|🐳|🐋|🦈|🐊|🐅|🐆|🦍|🐘|🦏|🐪|🐫|🐃|🐂|🐄|🐎|🐖|🐏|🐑|🐐|🦌|🐕|🐩|🐈|🐓|🦃|🕊|🐇|🐁|🐀|🐿|🐾|🐉|🐲|🌵|🎄|🌲|🌳|🌴|🌱|🌿|☘|🍀|🎍|🎋|🍃|🍂|🍁|🍄|🌾|💐|🌷|🌹|🥀|🌺|🌸|🌼|🌻|🌞|🌝|🌛|🌜|🌚|🌖|🌗|🌘|🌑|🌒|🌓|🌔|🌙|🌎|🌍|🌏|💫|⭐|🌟|✨|⚡|☄|💥|🔥|🌪|🌈|☀|🌤|⛅|🌥|☁|🌦|🌧|⛈|🌩|🌨|❄|☃|⛄|🌬|💨|💧|💦|☔|☂|🌊|🌫|🍏|🍎|🍐|🍊|🍋|🍌|🍉|🍇|🍓|🍈|🍒|🍑|🍍|🥝|🍅|🍆|🥑|🥒|🌶|🌽|🥕|🥔|🍠|🥐|🍞|🥖|🧀|🥚|🍳|🥞|🥓|🍗|🍖|🌭|🍔|🍟|🍕|🥙|🌮|🌯|🥗|🥘|🍝|🍜|🍲|🍛|🍣|🍱|🍤|🍙|🍚|🍘|🍥|🍢|🍡|🍧|🍨|🍦|🍰|🎂|🍮|🍭|🍬|🍫|🍿|🍩|🍪|🌰|🥜|🍯|🥛|🍼|☕|🍵|🍶|🍺|🍻|🥂|🍷|🥃|🍸|🍹|🍾|🥄|🍴|🍽|⚽|🏀|🏈|⚾|🏐|🏉|🎾|🎱|🏓|🏸|🥅|🏒|🏑|🏏|⛳|🏹|🎣|🥊|🥋|🎽|⛸|🎿|⛷|🏂|🏋‍♀|🏋🏻‍♀|🏋🏼‍♀|🏋🏽‍♀|🏋🏾‍♀|🏋🏿‍♀|🏋‍♂|🏋🏻‍♂|🏋🏼‍♂|🏋🏽‍♂|🏋🏾‍♂|🏋🏿‍♂|🤼‍♀|🤼‍♂|🤸‍♀|🤸🏻‍♀|🤸🏼‍♀|🤸🏽‍♀|🤸🏾‍♀|🤸🏿‍♀|🤸‍♂|🤸🏻‍♂|🤸🏼‍♂|🤸🏽‍♂|🤸🏾‍♂|🤸🏿‍♂|⛹‍♀|⛹🏻‍♀|⛹🏼‍♀|⛹🏽‍♀|⛹🏾‍♀|⛹🏿‍♀|⛹‍♂|⛹🏻‍♂|⛹🏼‍♂|⛹🏽‍♂|⛹🏾‍♂|⛹🏿‍♂|🤺|🤾‍♀|🤾🏻‍♀|🤾🏼‍♀|🤾🏾‍♀|🤾🏾‍♀|🤾🏿‍♀|🤾‍♂|🤾🏻‍♂|🤾🏼‍♂|🤾🏽‍♂|🤾🏾‍♂|🤾🏿‍♂|🏌‍♀|🏌🏻‍♀|🏌🏼‍♀|🏌🏽‍♀|🏌🏾‍♀|🏌🏿‍♀|🏌‍♂|🏌🏻‍♂|🏌🏼‍♂|🏌🏽‍♂|🏌🏾‍♂|🏌🏿‍♂|🏇|🏇🏻|🏇🏼|🏇🏽|🏇🏾|🏇🏿|🏄‍♀|🏄🏻‍♀|🏄🏼‍♀|🏄🏽‍♀|🏄🏾‍♀|🏄🏿‍♀|🏄‍♂|🏄🏻‍♂|🏄🏼‍♂|🏄🏽‍♂|🏄🏾‍♂|🏄🏿‍♂|🏊‍♀|🏊🏻‍♀|🏊🏼‍♀|🏊🏽‍♀|🏊🏾‍♀|🏊🏿‍♀|🏊‍♂|🏊🏻‍♂|🏊🏼‍♂|🏊🏽‍♂|🏊🏾‍♂|🏊🏿‍♂|🤽‍♀|🤽🏻‍♀|🤽🏼‍♀|🤽🏽‍♀|🤽🏾‍♀|🤽🏿‍♀|🤽‍♂|🤽🏻‍♂|🤽🏼‍♂|🤽🏽‍♂|🤽🏾‍♂|🤽🏿‍♂|🚣‍♀|🚣🏻‍♀|🚣🏼‍♀|🚣🏽‍♀|🚣🏾‍♀|🚣🏿‍♀|🚣‍♂|🚣🏻‍♂|🚣🏼‍♂|🚣🏽‍♂|🚣🏾‍♂|🚣🏿‍♂|🚵‍♀|🚵🏻‍♀|🚵🏼‍♀|🚵🏽‍♀|🚵🏾‍♀|🚵🏿‍♀|🚵‍♂|🚵🏻‍♂|🚵🏼‍♂|🚵🏽‍♂|🚵🏾‍♂|🚵🏿‍♂|🚴‍♀|🚴🏻‍♀|🚴🏼‍♀|🚴🏽‍♀|🚴🏾‍♀|🚴🏿‍♀|🚴‍♂|🚴🏻‍♂|🚴🏼‍♂|🚴🏾‍♂|🚴🏿‍♂|🏆|🥇|🥈|🥉|🏅|🎖|🏵|🎗|🎫|🎟|🎪|🤹‍♀|🎭|🎨|🎬|🎤|🎧|🎼|🎹|🥁|🎷|🎺|🎸|🎻|🎲|♟|🎯|🎳|🎮|🎰|🚗|🚕|🚙|🚌|🚎|🏎|🚓|🚑|🚒|🚐|🚚|🚛|🚜|🛴|🚲|🛵|🏍|🚨|🚔|🚍|🚘|🚖|🚡|🚠|🚟|🚃|🚋|🚞|🚝|🚄|🚅|🚈|🚂|🚆|🚇|🚊|🚉|✈|🛫|🛬|🛩|💺|🛰|🚀|🚁|🛶|⛵|🚤|🛥|🛳|⛴|🚢|⚓|⛽|🚧|🚦|🚥|🚏|🗺|🗿|🗽|🗼|🏰|🏯|🏟|🎡|🎢|🎠|⛲|⛱|🏖|🏝|🏜|🌋|🏔|🗻|🏕|🏠|🏡|🏘|🏚|🏗|🏭|🏢|🏬|🏣|🏤|🏥|🏦|🏨|🏪|🏫|🏩|💒|🏛|⛪|🕌|🕋|⛩|🛤|🛣|🗾|🎑|🏞|🌅|🌄|🌠|🎇|🎆|🌇|🌆|🏙|🌃|🌌|🌉|🌁|⌚|📱|📲|💻|⌨|🗜|💽|💾|💿|📀|📼|📷|📸|📹|🎥|📽|🎞|📞|☎|📟|📠|📺|📻|⏱|⏲|⏰|🕰|⌛|⏳|📡|🔋|🔌|💡|🔦|🛢|💸|💵|💴|💶|💷|💰|💳|💎|⚖|🔧|🔨|⚒|🛠|⛏|🔩|⚙|⛓|🔫|💣|🔪|🗡|⚔|🚬|🏺|🔮|📿|💈|⚗|🔭|🔬|🕳|💊|💉|🌡|🚽|🚰|🚿|🛁|🛀|🛀🏻|🛀🏼|🛀🏽|🛀🏾|🛀🏿|🛎|🔑|🗝|🚪|🛋|🛏|🛌|🖼|🛍|🛒|🎁|🎈|🎏|🎀|🎊|🎉|🎎|🏮|🎐|✉|📩|📨|📧|💌|📥|📤|📦|🏷|📪|📫|📬|📭|📮|📯|📜|📃|📄|📑|📊|📈|📉|🗓|📆|📅|📇|🗃|🗳|🗄|📋|📁|📂|🗂|🗞|📰|📓|📔|📒|📕|📗|📘|📙|📚|📖|🔖|🔗|📎|🖇|📐|📏|📌|📍|✂|🖊|🖋|✒|🖌|🖍|📝|✏|🔍|🔎|🔏|🔐|🔒|🔓|❤|💛|💚|💙|💜|🖤|💔|❣|💕|💞|💓|💗|💖|💘|💝|💟|🕎|☯|☦|🛐|🆔|⚛|🉑|☢|☣|📴|📳|🆚|🆑|🅾|🆘|⛔|📛|🚫|💯|💢|♨|🚷|🚯|🚳|🚱|🔞|📵|🚭|🔅|🔆|🚸|🔱|⚜|🔰|♻|🈯|💹|❎|🌐|💠|🌀|💤|🏧|🚾|♿|🛂|🛃|🛄|🛅|🚹|🚺|🚼|🚻|🚮|🎦|📶|🈁|🔣|🔤|🔡|🔠|🔂|🔄|🔃|🎵|🎶|🔚|🔙|🔛|🔝|🔜|🔈|🔇|🔉|🔊|🔔|🔕|📣|📢|👁‍🗨|💬|💭|🗯|♠|♣|♥|🎴|🕐|🕑|🕒|🕓|🕔|🕕|🕖|🕗|🕘|🕙|🕚|🕛|🕜|🕝|🕞|🕟|🕠|🕡|🕢|🕣|🕤|🕥|🕦|🕧]/g;
        characteres = msn.match(regexEmojic);
  
        if (!!characteres) {
          return true;
        }
  
        return false;
    }

    const processMessage = (msn) => {
        //const regex = /{([^}]*)}/g;
        const regexWord = /\[([\w\s]*)\]/g;
        const regexNonWord = /\[([\W]*)\]/g;
        var grupos;
        var gruposNonWord;
        let msns = [];
        
        while ((grupos = regexWord.exec(msn)) !== null) {
        //console.log("Llaves:", grupos[0], "\tPosición:", grupos.index, "\tColor:", grupos[1]);
        msns.push(['[', grupos[1], ']'].join(''));        
        }

        while ((gruposNonWord = regexNonWord.exec(msn)) !== null) {
        //console.log("Llaves:", grupos[0], "\tPosición:", grupos.index, "\tColor:", grupos[1]);
        msns.push(['[', gruposNonWord[1], ']'].join(''));        
        }

        const tally = {};
        const uniqueLabels = [];

        for(let i = 0; i < msns.length; i++) {
        if(tally.hasOwnProperty(msns[i])) {
            tally[msns[i]]++;
        } else {
            tally[msns[i]] = 1;
        }
        };

        for(let date in tally) {
        uniqueLabels.push(date);
        }

        const isSpecial = isSpecialCharacters(msn);
        let divide = Math.ceil(msn.length / (isSpecial ? 70 : 160));
        setMessageInfo({
        length: msn.length,
        count: divide
        });

        setLabelSelected([...uniqueLabels]);
    }

    const onActiveCharacters = ({ target }) => {
        setIsSpecialChar(target.checked);

        if (!target.checked) {
            let newValue = message;
            newValue = newValue.split('').filter(char => allowedGSMChars.includes(char)).join('');
            processMessage(newValue);
            setValuesConfig({...valuesConfig, message: newValue});
        }
    }

    const onEmojiClick = (emojiData, event) => {
        if (isSpecialChar) {
            onPushLabel(emojiData.emoji);
        }
    };

    const onPushLabel = (lb) => {
        let input = document.getElementsByName('message')[0];
  
        if (document.selection) {
          input.focus();
          let sel = document.selection.createRange();
          sel.text = lb;
        } else if (input.selectionStart || input.selectionStart === '0') {
            var startPos = input.selectionStart;
            var endPos = input.selectionEnd;
            input.value = input.value.substring(0, startPos)
                + lb
                + input.value.substring(endPos, input.value.length);
        } else {
            input.value += lb;
        }
  
        processMessage(input.value);
        setValuesConfig({...valuesConfig, 'message': input.value});
    }

    const renderModalConfigPhones = () => (
        <CenteredModalConfigPhones
          title={'My test numbers'}
          footer={(
            <small className={`text-muted fst-italic`}>
                You can add up to 5 phone numbers
            </small>
          )}
          size={'md'}
        >
            <PhonesNumber />
        </CenteredModalConfigPhones>
    );

    const renderModalSendPhones = () => (
        <CenteredModalSendPhones
            title={'Send test message'}
            size={'md'}
        >
            <PhonesNumberSend />
        </CenteredModalSendPhones>
    );

    const renderModalConfigMessages = () => (
        <CenteredModalConfigMessages
          title={'Messages template'}
          footer={(
            <small className={`text-muted fst-italic`}>
                Choose a message template
            </small>
          )}
        >
            <Templates onMessageSelected={messageSelected} onMessageSelectedToEdit={messageSelectedToEdit} />
        </CenteredModalConfigMessages>
    );

    const messageSelected = (msn) => {
        setValuesConfig({...valuesConfig, message: msn});
        processMessage(msn);
        toggleConfigMessages();
        setMessageEdit(0);
    }

    const messageSelectedToEdit = (msn, index) => {
        //setAttemptId(0);
        setValidated(false);

        setValuesConfig({ message: msn, fields: labels });
        processMessage(msn);
        toggleConfigMessages();
        setMessageEdit(index);
        const element = document.getElementsByName('message')[0];
        window.setTimeout(() => element.focus(), 0);
    }

    const handleSubmit = async (e) => {
        try {
            const form = e.currentTarget;
            e.preventDefault();
            setValidated(false);

            if(!hookName) {
                toast.warning(`Choose a webhook template to edit.`, {
                    theme: 'colored'
                });
                return;
            }

            if (form.checkValidity() === false) {
                e.stopPropagation();
                setValidated(true);
                return;
            }

            setIsLoading(true);
            const { message } = valuesConfig;

            const result = await updateOrderHook(JSON.stringify({
                message,
                hookId
            }));            
            toast.success(`Data saving success.`, {
                theme: 'dark'
            });
            await loadHooks();
        } catch (error) {
            const { response: { data: { errors } } } = error;
            toast.error(`Error saving data. ${errors || ''}`, {
                theme: 'colored'
            });
        } finally {
            setIsLoading(false);            
        }       
    };

    const onHandleCancel = () => {
        onCancel();
        setValidated(false);
        setValuesConfig({ message: '', fields: [] });
        setMessageInfo({ length: 0, count: 0 });
        setMessageEdit(null);
    }

    return (
        <>
            <FalconComponentCard className={'animate__animated animate__fadeIn'}>
                <FalconComponentCard.Header title={`${(messageEdit !== null) ? 'Edit template': `Message Composer ${hookName}`}`} light={false}  />
                <FalconComponentCard.Body>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} className={'animate__animated animate__fadeIn'}>                            
                        <Form.Group className="mb-3" controlid="message">
                            <Form.Label controlid="message">Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                required
                                placeholder="Type message here"
                                style={{ height: '100px' }}
                                name={'message'}
                                value={message}
                                size='sm'
                                onChange={useHandleChangeForm}
                            />
                            <Form.Control.Feedback type="invalid">Please provide a valid message template.</Form.Control.Feedback>
                    
                            <Row className="g-2">
                                <Col>
                                    <Form.Text id="mutedMessage" muted>
                                        [<strong>{messageInfo.length}</strong>] characters used approx, [<strong>{messageInfo.count}</strong>] SMS messages.
                                    </Form.Text>
                                </Col>
                                <Col md className='d-flex justify-content-end' style={{alignItems: 'baseline'}}>
                                    <CustomPopover body={`${isSpecialChar ? 'Inactive' : 'Active'} Characters`}>
                                        <Form.Check 
                                            type='switch'
                                            id={`checkedCharSwitch`}
                                            label=''
                                            defaultChecked={isSpecialChar}
                                            onClick={onActiveCharacters}
                                        />
                                    </CustomPopover>
                                                            
                                    {
                                        isSpecialChar && (
                                            <CustomPopover className={'animate__animated animate__fadeIn'} body={<EmojiPicker onEmojiClick={onEmojiClick} />} trigger={'click'} styles={{maxWidth: 'initial'}} placement={'left'}>
                                                <Button size='sm' variant="light" className="mt-2" style={{color: 'var(--falcon-colored-link-hover-color-warning)'}}>
                                                    <BsEmojiSmileFill />
                                                </Button>
                                            </CustomPopover>
                                        )
                                    }                                         
                                    <CustomPopover body={'show messaging templates'}>
                                        <Button size='sm' variant="light" className="justify-content-end mt-2" onClick={toggleConfigMessages}>
                                            <FaList />
                                        </Button>
                                    </CustomPopover>
                                    <CustomPopover body={'Configure phone numbers'}>  
                                        <Button size='sm' variant="light" className="mt-2" onClick={toggleConfigPhones}>
                                            <FaCog />
                                        </Button>
                                    </CustomPopover> 
                                    <CustomPopover body={'Sent message test'}>
                                        <Button size='sm' variant="light" className="mt-2" onClick={toggleSendPhones}>
                                            <FaPaperPlane />
                                        </Button>
                                    </CustomPopover>           
                                </Col>
                            </Row>      
                        </Form.Group>
                            <Form.Group className='mb-3'>
                                <LabelForm labels={fields} onPushLabel={onPushLabel} />
                            </Form.Group>
                        <Form.Group className="mb-3">
                            {
                                isLoadingInitial && 
                                (
                                    <Spinner animation="grow" className="position-absolute start-50" variant="primary" style={{marginRight:10, verticalAlign:'middle', height:'1.82rem', width:'1.82rem'}} /> 
                                )
                            }
                            <div className="float-end align-middle">                                    
                                <Button variant="secondary" size='sm' className='me-2' onClick={onHandleCancel}>Cancel</Button>
                                <Button variant="primary" size='sm' type="submit">Save</Button>
                            </div>        
                        </Form.Group>                    
                    </Form>
                </FalconComponentCard.Body>
            </FalconComponentCard>
            {renderModalConfigMessages()}
            {renderModalConfigPhones()}
            {renderModalSendPhones()}
        </>
    )
}